import { add, format, formatDuration, intervalToDuration, isValid, isWeekend, startOfDay, sub } from 'date-fns';

export const SERVER_DATE_FORMAT = 'yyyy-MM-dd';
export const SERVER_DATE_TIME_FORMAT = 'yyyy-MM-dd HH:mm:ss';
export const UI_DATE_FORMAT = 'MM/dd/yyyy';
export const UI_DATE_TIME_FORMAT = 'MM/dd/yyyy HH:mm:ss';

export const formatDate = (date?: Date, formatString = UI_DATE_FORMAT) =>
    date && isValid(date) ? format(date, formatString) : undefined;
export const formatDateTime = (date?: Date, formatString = UI_DATE_TIME_FORMAT) =>
    date && isValid(date) ? format(date, formatString) : undefined;

const formatDistanceLocale = {
    lessThanXSeconds: '{{count}}s',
    xSeconds: '{{count}}s',
    halfAMinute: '30s',
    lessThanXMinutes: '{{count}}m',
    xMinutes: '{{count}}m',
    aboutXHours: '{{count}}h',
    xHours: '{{count}}h',
    xDays: '{{count}}d',
    aboutXWeeks: '{{count}}w',
    xWeeks: '{{count}}w',
    aboutXMonths: '{{count}}m',
    xMonths: '{{count}}m',
    aboutXYears: '{{count}}y',
    xYears: '{{count}}y',
    overXYears: '{{count}}y',
    almostXYears: '{{count}}y',
};

export const duration = (start: Date, end: Date) =>
    formatDuration(intervalToDuration({ start, end }), {
        locale: {
            formatDistance: (token: keyof typeof formatDistanceLocale, count) =>
                formatDistanceLocale[token].replace('{{count}}', String(count)),
        },
    });

export const parseDate = (dateString?: string) => {
    if (!dateString) {
        return undefined;
    }

    if (dateString.endsWith('Z')) {
        return new Date(dateString);
    }

    return new Date(dateString.includes('T') ? dateString.replace('-04:00', '') : `${dateString}T00:00:00`);
};

export const today = () => startOfDay(new Date());
export const yesterday = () => sub(today(), { days: 1 });
export const tomorrow = () => add(today(), { days: 1 });

export const lastBusinessDay = () => {
    let date = yesterday();

    while (isWeekend(date)) {
        date = sub(date, { days: 1 });
    }

    return date;
};
